import React from 'react';
import { SectionHeading } from './SectionHeading';
import { progressionStages } from '../data/landing';
export function ProgressionSection() {
  return <section aria-labelledby="progresion" className="bg-cream-deep" data-id="element-170" data-mp="ydw0xqvrdu34">
      
    </section>;
}